import React, { ReactNode } from 'react';
import classNames from 'classnames';
import Spinner, { SpinnerType } from 'legacy/common/components/spinner/Spinner';

interface ButtonProps {
  variant: 'primary' | 'primaryDark' | 'secondary' | 'inverted' | 'danger';
  size?: 'small' | 'regular' | 'large' | 'xlarge';
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  onClick: (...args: any[]) => void; // Accept any number of arguments of any type
  isIconButton?: boolean;
  loading?: boolean;
}
const Button = ({
  variant,
  children,
  onClick,
  className,
  loading,
  disabled,
  size = 'regular',
  isIconButton = false
}: ButtonProps) => {
  const baseClasses = 'mt-3 flex justify-center items-center rounded-full';
  const iconButtonClasses =
    'h-11 w-11 flex justify-center items-center rounded-full';
  const variantStyles = {
    primary: 'bg-[#6585FF] text-white',
    primaryDark: 'bg-[#3853C4] text-white',
    secondary: 'bg-[#EFF2FF] text-[#3853C4]',
    inverted: 'text-[#ab0a0a] font-bold',
    danger: 'bg-[#ab0a0a] text-white'
  };
  const sizeStyles = {
    small: 'h-8 px-3',
    regular: 'h-11 px-4',
    large: 'h-[44px] px-6 text-base font-semibold',
    xlarge: 'h-[49px] px-10 text-lg font-semibold'
  };

  const btnTypeClasses = isIconButton ? iconButtonClasses : baseClasses;

  const variantClasses = variantStyles[variant];
  const sizeClasses = sizeStyles[size];

  return (
    <button
      className={classNames(
        btnTypeClasses,
        variantClasses,
        sizeClasses,
        className,
        {
          'cursor-not-allowed': disabled || loading,
          'opacity-70 bg-neutral-300': disabled
        }
      )}
      onClick={onClick}
      type="button"
      disabled={disabled || loading}
    >
      {loading ? <Spinner type={SpinnerType.DEFAULT} /> : children}
    </button>
  );
};

export default Button;
